import React, { memo } from 'react';

type IconProps = {
  className?: string;
  color?: string;
  size?: number;
};

export const ThinkingIcon = memo(({ className, size = 24 }: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      stroke="currentColor">
      <g transform="translate(3.034248, 1.000000)">
        <circle cx="6.85" cy="9.522" r="1.642" strokeWidth="1.25" />
        <circle cx="12.432" cy="5.91" r="1.345" strokeWidth="1.25" />
        <circle cx="9.936" cy="14.97" r="1.345" strokeWidth="1.25" />
        <path
          d="M13.936,10.184 C14.307,10.184 14.643,10.334 14.887,10.578 C15.13,10.821 15.281,11.157 15.281,11.529 C15.281,11.9 15.13,12.236 14.887,12.48 C14.643,12.723 14.307,12.874 13.936,12.874 C13.564,12.874 13.228,12.723 12.985,12.48 C12.741,12.236 12.591,11.9 12.591,11.529 C12.591,11.157 12.741,10.821 12.985,10.578 C13.228,10.334 13.564,10.184 13.936,10.184Z"
          strokeWidth="1.25"
        />
        <path
          d="M16.266,23.086 C16.316,20.755 16.401,19.386 16.521,18.98 C17.249,16.519 19.38,10.71 19.38,8.639 C19.38,3.562 15.41,0 10.333,0 C7.813,0 5.1,1.09 2.909,4.551 C1.948,6.07 2.261,7.524 1.625,9.318 C1.069,10.888 0.528,12.631 0,14.548 C0.958,14.754 2.131,14.912 3.517,15.02 L3.805,20.079 L6.947,20.079 L6.947,23.086"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line x1="12.432" y1="4.156" x2="12.432" y2="1.029" strokeWidth="1.25" strokeLinecap="round" />
        <line x1="9.936" y1="23.201" x2="9.936" y2="16.899" strokeWidth="1.25" strokeLinecap="round" />
        <polyline
          points="12.453 23.201 12.453 17.899 13.936 16.417 13.936 13.297"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <polyline
          points="6.85 7.44 6.85 3.304 8.492 2.337 8.492 0.873"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
          transform="translate(7.671, 4.156) rotate(-180) translate(-7.671, -4.156)"
        />
      </g>
    </svg>
  );
});
